import { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer/Footer';
import TrainingTable from '../../components/Tables/Warren/Training';
import ManualPage from '../../components/ManualPage';

import { SINavbar } from '../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const SpringhillTraining = () => {
	return (
		<>
			<ManualPage />
		</>
	);
};

export default SpringhillTraining;
